import { State } from 'store';

export default function getFileMap(state: State) {
  return state.startWorkflow.steps.provideFiles.fileMap;
}
